import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { EndCustomerDto } from '.';

export class EndCustomerResponseModel extends GlobalResponseObject{
    data?: EndCustomerDto;

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: EndCustomerDto){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
}
}
